export const textBlocks = (text: string) => {
  return text.split("\n")
}
